module.exports = __webpack_public_path__ + "img/LUB00349.a02fbdce.png";